export default [
  {
    generate({ parameters, treatments, answers, extraAnswers }) {
      const textPieces = []

      const biologicTreatmentsMedicine = ['Mepolizumabe', 'Omalizumabe', 'Dupilumabe', 'Benralizumabe', 'Tezepelumabe']
      const indicatedTreatmentsId = new Set(Object.keys(extraAnswers['indicated-treatments'] ?? {}))
      const selectedBiologicTreatments = treatments
        .filter(
          (treatment) =>
            indicatedTreatmentsId.has(String(treatment.id)) &&
            biologicTreatmentsMedicine.some((medicine) => treatment.medicine.name.startsWith(medicine)),
        )
        .map((treatment) => treatment.medicine.name)

      if (!selectedBiologicTreatments.length) {
        return []
      }

      const firstPiece = [
        `Tendo em vista a caracterização como ${
          parameters['asthma:hypothesis']?.label.text.toLocaleLowerCase() ?? '-'
        }`,
        'refratária ao tratamento descrito',
        ...(!['0', 'sem-informacao'].includes(answers['9'])
          ? [`com ${answers['9'].replace('+', ' ou mais')} exacerbações no intervalo de um ano`]
          : []),
        `prescrevo ${selectedBiologicTreatments.join(', ')}, conforme receita em anexo.`,
      ].join(', ')

      textPieces.push(
        firstPiece,
        `O uso será por tempo indeterminado, enquanto o paciente estiver se beneficiando da terapia.`,
        'Ressalto que o objetivo em relação ao tratamento da asma aqui solicitado é atingir e manter  o controle da doença, que é definido como a intensidade com que as suas manifestações são suprimidas pelo tratamento.',
        'O controle da doença compreende dois objetivos distintos: Primeiro, o controle das limitações clínicas presentes, ou seja, sintomas mínimos durante o dia e ausência de sintomas à noite, pouca ou nenhuma necessidade de uso de medicamentos de alívio e ausência de limitação das atividades físicas; e, segundo, a redução dos riscos futuros, ou seja, das exacerbações, da perda da função pulmonar e dos efeitos adversos do tratamento. ',
        'Comprometo-me a realizar seguimento do caso em consultas regulares para orientar o paciente quanto ao seguimento correto do tratamento, monitorar sua adesão às medidas propostas e observar os efeitos positivos do medicamento assim como tratar com rapidez e responsabilidade os possíveis efeitos adversos associados à terapêutica proposta.',
        'Atenciosamente,',
      )

      return textPieces
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [],
    },
  },
]
